export enum LinkTypes {
    None,
    HyperLink,
    Screen,
    DeepLink
}